// extracted by mini-css-extract-plugin
module.exports = {"wrap":"pb-z","heading":"qb-z","brandPromo":"rb-z"};